<template>
  <v-container class="pa-0">
      <v-container class="wrapper pa-3">
          <v-btn
            color="primary"
            outlined
            @click="openPanelsList"
            :loading="loading"
          >
          <span>{{ $t('add-new-panel') }}</span>
          <v-icon size="18" class="mr-1">mdi-plus</v-icon>
          </v-btn>
          <v-container
            class="pa-0 mt-5 columns"
          >
            <v-container
              class="pa-4 column-panel d-flex justify-space-between align-center mt-2"
              v-for="(panel, index) in addedPanels"
              :key="index"
            >
              <div class="d-flex align-center gap-3">
                <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
                <v-card-text class="pa-0 text-body-2">{{ panel.panel_name || panel.name }}</v-card-text>
              </div>
              <div class="d-flex align-center gap-8">
                <v-card-text class="pa-0 text-body-2 mr-9">{{ panel.productVariant || panel.digi_kala_product.length }} {{ $t('product-variant') }}</v-card-text>
                <div @click="openTableDialog('edit', panel, index)">
                  <svg style="cursor: pointer;" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.66602 14.5002H13.3327M3.77668 9.29156C3.49243 9.57645 3.33275 9.96244 3.33268 10.3649V12.5002H5.48135C5.88402 12.5002 6.27002 12.3402 6.55468 12.0549L12.888 5.71822C13.1722 5.43329 13.3317 5.0473 13.3317 4.64489C13.3317 4.24248 13.1722 3.85649 12.888 3.57156L12.2627 2.94489C12.1217 2.80379 11.9542 2.69187 11.7699 2.61554C11.5856 2.5392 11.388 2.49994 11.1885 2.5C10.9891 2.50006 10.7915 2.53944 10.6073 2.6159C10.423 2.69235 10.2556 2.80437 10.1147 2.94556L3.77668 9.29156Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
            </v-container>
          </v-container>
      </v-container>
      <!-- panels list-->
      <v-dialog
        v-model="panelsListDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        max-width="550"
      >
        <v-card class="pa-5">
          <v-container class="pa-0 d-flex align-center justify-space-between mb-7">
            <v-card-text class="pa-0 text-body-1">{{ $t('select-panel') }}</v-card-text>
            <v-icon style="cursor: pointer;" @click="panelsListDialog = false">mdi-close</v-icon>
          </v-container>
          <div v-if="items.length > 0">
            <v-card-text class="pa-0 text-body-2">{{ $t('To connect to this product, choose from the panels below') }}</v-card-text>
            <v-container
              class="pa-0 mt-5 columns"
            >
              <v-container
                class="pa-4 d-flex justify-space-between align-center mt-2"
                v-for="(item, index) in items"
                :key="index"
                @click="selectPanel(item)"
                :class="{'column-panel': !item.isSelected, 'column-panel-disabled': item.isSelected}"
              >
                <div class="d-flex align-center gap-3">
                  <v-card-text
                    class="pa-0 text-caption"
                    :style="{'color': item.isSelected ? 'silver' : ''}"
                  >
                    {{ index + 1 }}
                  </v-card-text>
                  <v-card-text
                    class="pa-0 text-body-2"
                    :style="{'color': item.isSelected ? 'silver' : ''}"
                  >
                    {{ item.panel_name }}
                  </v-card-text>
                </div>
                <div class="d-flex align-center gap-5">
                  <v-card-text
                    v-if="!item.isSelected"
                    class="pa-0 text-body-2"
                    :style="{'color': item.panel_status == 'active' ? '#137333' : '#ff5252'}"
                  >
                  {{ $t(item.panel_status) }}
                  </v-card-text>
                  <v-card-text
                    v-else
                    class="pa-0 text-body-2"
                    style="color: silver;"
                  >
                  {{ $t(item.panel_status) }}
                  </v-card-text>
                </div>
              </v-container>
            </v-container>
          </div>
          <div v-else>
            <v-card-text class="pa-0 text-body-2">
              {{ $t('no panel founded!') }}
              {{ $t('first add panels in integrator setting') }}
            </v-card-text>
          </div>
        </v-card>
      </v-dialog>
      <!--table-->
      <v-dialog
        v-model="tableDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        max-width="800"
      >
        <v-card class="pa-5">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text v-if="selectedPanel != null && tableDialogType == 'add'" class="pa-0 text-body-2">{{ $t('product-infomation') }} {{ selectedPanel.panel_name || selectedPanel.name }}</v-card-text>
            <v-card-text v-if="selectedPanel != null && tableDialogType == 'edit'" class="pa-0 text-body-2">{{ $t('edit-product') }} {{ selectedPanel.panel_name || selectedPanel.name}}</v-card-text>
            <v-icon size="20" @click="tableDialog = false">mdi-close</v-icon>
          </v-container>
          <v-container class="pa-0 d-flex justify-space-between align-center mt-9 mb-3">
              <v-btn
                color="secondary"
                outlined
                @click="openProductDialog('add')"
              >
                <span class="ml-2 mt-1">{{ $t('add-new-dkp-dkpc') }}</span>
                <v-icon size="16">mdi-plus</v-icon>
              </v-btn>
              <div class="d-flex align-center gap-2">
                <v-btn
                  color="success"
                  outlined
                  @click="activeAllProduct"
                >
                {{ $t('active-all') }}
                </v-btn>
                <v-btn
                  color="error"
                  outlined
                  @click="deactiveAllProduct"
                >
                {{ $t('deactive-all') }}
                </v-btn>
              </div>
          </v-container>
          <v-data-table
            :headers="tableHeaders"
            :items="tableItems"
            :items-per-page="-1"
            hide-default-footer
            :height="(isMobile || isTablet ? 265 : 265)"
            fixed-header
            :class="{'ma-5': isMobile}"
            class="product"
          >
              <template v-slot:header.digikala_product_code="{ header }">
                  <span class="ml-5">#</span>
                  <span>{{ header.text }}</span>
              </template>
              <template v-slot:header.product_variant_code="{ header }">
                  <span class="ml-5">#</span>
                  <span>{{ header.text }}</span>
              </template>
              <template v-slot:item.digikala_product_code="{ item, index }">
                  <v-container class="pa-0 d-flex align-center gap-2">
                      <span style="width: 20px;">{{ index + 1 }}</span>
                      <v-card-text class="pa-0 text-body-2">DKP-{{ item.digikala_product_id }}</v-card-text>
                  </v-container>
              </template>
              <template v-slot:item.product_variant_code="{ item, index }">
                  <v-container class="pa-0 d-flex align-center gap-2">
                      <span style="width: 20px;">{{ index + 1 }}</span>
                      <v-card-text class="pa-0 text-body-2">DKPC-{{ item.product_variant_id }}</v-card-text>
                  </v-container>
              </template>
              <template v-slot:item.other="{ item }">
                  <v-card-text
                      class="pa-0 text-caption"
                      :style="{ 'color': item.status == 'active' ? 'rgb(19, 115, 51)' : 'rgb(255, 82, 82)'}"
                  >
                  {{ $t(item.status) }}
                  </v-card-text>
              </template>
              <template v-slot:header.edit="{ header }">
                  <v-container class="pa-0 d-flex align-center ma-0 gap-3">
                      {{ header.text }}
                      <div
                          @click="openDeleteProductDialog('all')"
                          style="cursor: pointer;"
                      >
                          <svg class="mt-1" width="15" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.625 3.375H5.5C5.56875 3.375 5.625 3.31875 5.625 3.25V3.375ZM5.625 3.375H10.375V3.25C10.375 3.31875 10.4312 3.375 10.5 3.375H10.375V4.5H11.5V3.25C11.5 2.69844 11.0516 2.25 10.5 2.25H5.5C4.94844 2.25 4.5 2.69844 4.5 3.25V4.5H5.625V3.375ZM13.5 4.5H2.5C2.22344 4.5 2 4.72344 2 5V5.5C2 5.56875 2.05625 5.625 2.125 5.625H3.06875L3.45469 13.7969C3.47969 14.3297 3.92031 14.75 4.45312 14.75H11.5469C12.0813 14.75 12.5203 14.3313 12.5453 13.7969L12.9312 5.625H13.875C13.9438 5.625 14 5.56875 14 5.5V5C14 4.72344 13.7766 4.5 13.5 4.5ZM11.4266 13.625H4.57344L4.19531 5.625H11.8047L11.4266 13.625Z" fill="black"></path>
                          </svg>
                      </div>
                  </v-container>
              </template>
              <template v-slot:item.edit="{ item, index }">
                  <v-container class="pa-0 d-flex align-center ma-0 justify-space-between">
                      <div
                          style="cursor: pointer;"
                          class="pr-2"
                          @click="openProductDialog('edit', item)"
                      >
                          <svg width="15" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.66797 14.5002H13.3346M3.77864 9.29156C3.49438 9.57645 3.33471 9.96244 3.33464 10.3649V12.5002H5.4833C5.88597 12.5002 6.27197 12.3402 6.55664 12.0549L12.89 5.71822C13.1741 5.43329 13.3337 5.0473 13.3337 4.64489C13.3337 4.24248 13.1741 3.85649 12.89 3.57156L12.2646 2.94489C12.1236 2.80379 11.9562 2.69187 11.7718 2.61554C11.5875 2.5392 11.39 2.49994 11.1905 2.5C10.991 2.50006 10.7935 2.53944 10.6092 2.6159C10.425 2.69235 10.2576 2.80437 10.1166 2.94556L3.77864 9.29156Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                          </svg>
                      </div>
                      <div
                          @click="openDeleteProductDialog('single', item, index)"
                          style="cursor: pointer;"
                      >
                          <svg width="15" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.625 3.375H5.5C5.56875 3.375 5.625 3.31875 5.625 3.25V3.375ZM5.625 3.375H10.375V3.25C10.375 3.31875 10.4312 3.375 10.5 3.375H10.375V4.5H11.5V3.25C11.5 2.69844 11.0516 2.25 10.5 2.25H5.5C4.94844 2.25 4.5 2.69844 4.5 3.25V4.5H5.625V3.375ZM13.5 4.5H2.5C2.22344 4.5 2 4.72344 2 5V5.5C2 5.56875 2.05625 5.625 2.125 5.625H3.06875L3.45469 13.7969C3.47969 14.3297 3.92031 14.75 4.45312 14.75H11.5469C12.0813 14.75 12.5203 14.3313 12.5453 13.7969L12.9312 5.625H13.875C13.9438 5.625 14 5.56875 14 5.5V5C14 4.72344 13.7766 4.5 13.5 4.5ZM11.4266 13.625H4.57344L4.19531 5.625H11.8047L11.4266 13.625Z" fill="black"></path>
                          </svg>
                      </div>
                  </v-container>
              </template>
          </v-data-table>
          <v-container class="pa-0 d-flex align-center gap-2 mt-9">
              <v-btn
                color="primary"
                height="32"
                @click="processPanel"
              >
              {{ tableDialogType == 'add' ? $t('confirm') : $t('edit') }}
              </v-btn>
              <v-btn
                color="secondary"
                height="32"
                outlined
                @click="tableDialog = false"
              >
              {{ $t('cancel') }}
              </v-btn>
          </v-container>
        </v-card>
      </v-dialog>
      <!--product-->
      <v-dialog
        v-model="productDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        max-width="800"
      >
        <v-card class="pa-5">
            <v-form ref="form" v-model="valid">
                <v-container class="pa-0 d-flex justify-space-between">
                    <v-card-text class="pa-0 text-body-1">{{ productDialogType == 'add' ? $t('add-new-variant') : $t('edit')}}</v-card-text>
                    <v-icon size="20" @click="productDialog = false">mdi-close</v-icon>
                </v-container>
                <v-card-text class="pa-0 text-body-2 mt-6">{{ $t('general-setting') }}</v-card-text>
                <v-container class="pa-0 d-flex justify-space-between align-center mt-4">
                    <div class="d-flex align-center gap-3" style="width: 360px;">
                        <v-text-field
                            v-model="newProduct.digikala_product_id"
                            label="DKP"
                            outlined
                            height="32"
                            dense
                            style="width: 45px;"
                            :rules="[v => !!v || $t('is-required')]"
                        />
                        <v-text-field
                            v-model="newProduct.product_variant_id"
                            label="DKPC"
                            outlined
                            height="32"
                            dense
                            style="width: 45px;"
                            :rules="[v => !!v || $t('is-required')]"
                        />
                    </div>
                    <v-container
                        class="wrapper-toggle d-flex align-center pa-0 ma-0"
                        style="width: 151px;"
                    >
                        <div
                          v-for="(item, index) in activatorOptions"
                          :key="index"
                          @click="selectStatusProduct(item)"
                          class="child flex-fill text-center"
                          :style="{
                          'background-color': selectedStatusProduct == item.value ? '#E5FEED' : '',
                          'border-color': selectedStatusProduct == item.value ? '#0066ff' : 'silver',
                          'color': selectedStatusProduct == item.value ? '#137333': ''
                          }"
                        >
                            <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
                        </div>
                    </v-container>
                </v-container>
                <v-container class="pa-0 d-flex justify-space-between align-center mt-9">
                    <div class="d-flex align-center gap-2">
                        <v-btn
                          color="primary"
                          height="32"
                          @click="checkValidation"
                        >
                        {{ productDialogType == 'add' ? $t('add') : $t('edit')}}
                        </v-btn>
                        <v-btn
                          color="secondary"
                          outlined
                          height="32"
                          @click="productDialog = false"
                        >
                        {{ $t('cancel') }}
                        </v-btn>
                    </div>
                </v-container>
            </v-form>
        </v-card>
      </v-dialog>
      <!--delete dialog-->
      <v-dialog
        v-if="deleteItem != null"
        v-model="deleteProductDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        max-width="350"
      >
          <v-card class="pa-5">
              <v-card-text class="pa-0 text-body-2">
                  {{ deleteTpye == 'single' ? $t('Are you sure you want to delete this item ?') : $t('are you sure you want to delete all items?') }}
              </v-card-text>
              <v-container class="pa-0" v-if="deleteTpye == 'single'">
                  <v-container class="pa-0 d-flex align-center gap-1 mt-5">
                      <v-card-text class="pa-0 text-body-2">DKP : </v-card-text>
                      <v-card-text class="pa-0 text-caption">{{ deleteItem.digikala_product_id }}</v-card-text>
                  </v-container>
                  <v-container class="pa-0 d-flex align-center gap-1 mt-3">
                      <v-card-text class="pa-0 text-body-2">DKPC : </v-card-text>
                      <v-card-text class="pa-0 text-caption">{{ deleteItem.product_variant_id }}</v-card-text>
                  </v-container>
                  <v-container class="pa-0 d-flex align-center gap-1 mt-2">
                      <v-card-text class="pa-0 text-body-2">{{ $t('status') }} : </v-card-text>
                      <v-card-text class="pa-0 text-caption">{{ $t(deleteItem.status) }}</v-card-text>
                  </v-container>
              </v-container>
              <v-container class="pa-0 d-flex align-center gap-2 mt-6">
                  <v-btn
                      color="error"
                      height="32"
                      @click="deleteProduct"
                  >
                  {{ $t('yes') }}
                  </v-btn>
                  <v-btn
                      color="secondary"
                      height="32"
                      outlined
                      @click="deleteProductDialog = false"
                  >
                  {{ $t('no') }}
                  </v-btn>
              </v-container>
          </v-card>
      </v-dialog>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      panelsListDialog: false,
      loading: false,
      items: [],
      addedPanels: [],
      tableDialog: false,
      selectedPanel: null,
      selectedPanelIndex: null,
      productDialog: false,
      selectedStatusProduct: null,
      newProduct: {
        panel_id: null,
        product_id: null,
        digikala_product_id: null,
        product_variant_id: null,
        status: null
      },
      tableHeaders: [],
      tableItems: [],
      valid: true,
      productDialogType: null,
      editedIndex: null,
      deleteProductDialog: false,
      deleteTpye: null,
      deleteItem: null,
      deletedIndex: null,
      productVariant: null,
      tableDialogType: null
    }
  },
  props: {
    digikalaPanel: Array
  },
  computed: {
    activatorOptions () {
      return [
        { label: this.$t('active'), value: 'active' },
        { label: this.$t('deactive'), value: 'deactive' }
      ]
    }
  },
  methods: {
    openPanelsList () {
      this.fetchPanelList()
    },
    fetchPanelList () {
      this.loading = true
      var app = this
      app.$axios.get(this.$apipoint + 'config/digikala/list')
        .then(r => {
          this.loading = false
          this.items = r.data

          this.items.forEach(item => {
            item.isSelected = this.addedPanels.some(panel =>
              panel.panel_name === undefined
                ? panel.name === item.panel_name && panel.status === item.panel_status
                : panel.panel_name === item.panel_name && panel.panel_status === item.panel_status
            )
          })

          /*  console.log('jadidddddd' + JSON.stringify(this.items)) */
          this.panelsListDialog = true
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
    },
    selectPanel (item) {
      if (!item.isSelected) {
        this.selectedPanel = item
        this.panelsListDialog = false
        this.openTableDialog('add')
      }
    },
    openTableDialog (type, item, index) {
      this.tableDialog = true
      this.tableDialogType = type
      if (type == 'add') {
        this.tableItems = []
      }
      if (type == 'edit' && item != null && index != null) {
        this.selectedPanel = item
        this.selectedPanelIndex = index
        /* console.log('salam' + JSON.stringify(item)) */
        this.tableItems = item.digi_kala_product || item.digi_kala_product
        /* console.log('khobi' + JSON.stringify(this.tableItems)) */
      }
    },
    openProductDialog (type, item) {
      this.productDialog = true
      this.productDialogType = type
      if (type == 'add') {
        this.selectedStatusProduct = 'active'
        this.newProduct.status = this.selectedStatusProduct
      }
      if (type == 'edit' && item != null) {
        this.newProduct = {
          panel_id: item.panel_id,
          product_id: item.product_id ? item.product_id : null,
          digikala_product_id: item.digikala_product_id,
          product_variant_id: item.product_variant_id,
          status: item.status
        }
        this.selectedStatusProduct = item.status
        /* console.log('iteme select shode' + JSON.stringify(item)) */
        this.editedIndex = this.tableItems.findIndex(obj => (obj.product_variant_id == item.product_variant_id && obj.digikala_product_id == item.digikala_product_id))
        /* console.log('edited index' + this.editedIndex) */
      }
    },
    checkValidation () {
      if (this.$refs.form.validate() && this.productDialogType == 'add') {
        this.addProduct()
      }
      if (this.$refs.form.validate() && this.productDialogType == 'edit') {
        this.editProduct()
      }
    },
    addProduct () {
      this.tableItems.push(this.newProduct)
      this.productDialog = false
      // console.log('table after add' + JSON.stringify(this.tableItems))
    },
    editProduct () {
      this.tableItems.splice(this.editedIndex, 1, this.newProduct)
      this.productDialog = false
      // console.log('table after edit' + JSON.stringify(this.tableItems))
    },
    openDeleteProductDialog (type, item, index) {
      this.deleteProductDialog = true
      this.deleteTpye = type
      if (this.deleteTpye == 'single' && item != null && index != null) {
        this.deleteItem = item
        this.deletedIndex = index
      }
    },
    deleteProduct () {
      if (this.deleteTpye == 'single') {
        this.tableItems.splice(this.deletedIndex, 1)
        // console.log('table after delete single' + JSON.stringify(this.tableItems))
      }
      if (this.deleteTpye == 'all') {
        this.tableItems = []
        // console.log('table after delete all' + JSON.stringify(this.tableItems))
      }
      this.deleteProductDialog = false
    },
    processPanel () {
      if (this.tableDialogType == 'add') {
        this.addPanel()
      }
      if (this.tableDialogType == 'edit') {
        this.editPanel()
      }
    },
    addPanel () {
      if (this.tableItems.length > 0) {
        if (!this.selectedPanel.digi_kala_product && !this.selectedPanel.productVariant) {
          this.$set(this.selectedPanel, 'digi_kala_product', [])
          this.$set(this.selectedPanel, 'productVariant', this.tableItems.length)
        }
        this.selectedPanel.digi_kala_product.push(...this.tableItems)
        this.addedPanels.push(this.selectedPanel)
        this.tableDialog = false
        this.$emit('update', this.addedPanels)
      } else {
        this.tableDialog = false
      }
    },
    editPanel () {
      if (this.tableItems.length > 0) {
        if (this.selectedPanel.digi_kala_product && this.selectedPanel.productVariant) {
          this.selectedPanel.digi_kala_product = this.tableItems
          this.selectedPanel.productVariant = this.tableItems.length
          this.addedPanels.splice(this.selectedPanelIndex, 1, this.selectedPanel)
          this.$emit('update', this.addedPanels)
          this.tableDialog = false
        }
        if (!this.selectedPanel.digi_kala_product && !this.selectedPanel.productVariant) {
          this.$set(this.selectedPanel, 'digi_kala_product', [])
          this.$set(this.selectedPanel, 'productVariant', this.tableItems.length)
          this.selectedPanel.digi_kala_product = this.tableItems
          this.selectedPanel.productVariant = this.tableItems.length
          this.addedPanels.splice(this.selectedPanelIndex, 1, this.selectedPanel)
          this.$emit('update', this.addedPanels)
          this.tableDialog = false
        }
        if (!this.selectedPanel.digi_kala_product || this.selectedPanel.digi_kala_product) {
          this.selectedPanel.digi_kala_product = this.tableItems
          this.addedPanels.splice(this.selectedPanelIndex, 1, this.selectedPanel)
          this.$emit('update', this.addedPanels)
          this.tableDialog = false
        }
      } else {
        this.addedPanels.splice(this.selectedPanelIndex, 1)
        this.$emit('update', this.addedPanels)
        this.tableDialog = false
      }
    },
    selectStatusProduct (item) {
      this.selectedStatusProduct = item.value
      this.newProduct.status = item.value
    },
    activeAllProduct () {
      this.tableItems = this.tableItems.map(item => ({ ...item, status: 'active' }))
      this.selectedStatusProduct = 'active'
      // console.log('table after active all' + JSON.stringify(this.tableItems))
    },
    deactiveAllProduct () {
      this.tableItems = this.tableItems.map(item => ({ ...item, status: 'deactive' }))
      this.selectedStatusProduct = 'deactive'
      // console.log('table after deactive all' + JSON.stringify(this.tableItems))
    }
  },
  beforeMount () {
    this.tableHeaders = [
      {
        text: this.$t('digikala-product-code'),
        align: 'start',
        sortable: false,
        value: 'digikala_product_code'
      },
      {
        text: this.$t('product-variant-code'),
        align: 'start',
        sortable: false,
        value: 'product_variant_code'
      },
      {
        text: this.$t('other'),
        align: 'start',
        sortable: false,
        value: 'other'
      },
      {
        text: this.$t('edit'),
        align: 'start',
        sortable: false,
        value: 'edit'
      }
    ]
  },
  mounted () {
    this.userInfo = JSON.parse(localStorage.getItem('token'))
  },
  watch: {
    productDialog (val) {
      if (!val) {
      // reset keys
        this.newProduct = {
          panel_id: this.selectedPanel.id,
          product_id: null,
          digikala_product_id: null,
          product_variant_id: null,
          status: null
        }
        // reset form
        this.$refs.form.reset()
        // reset toggle button
        this.selectedStatusProduct = null
      }
    },
    selectedPanel (newVal) {
      this.newProduct.panel_id = newVal ? newVal.id : null
    },
    digikalaPanel: {
      handler (val) {
        if (val && val.length > 0) {
          // console.log('final: ' + JSON.stringify(val))
          this.addedPanels = val
        } else {
          this.addedPanels = []
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>
.wrapper {
background-color: #FCFCFC;
}
.columns .column-panel {
border: 1px solid silver;
border-radius: 4px;
cursor: pointer;
}
.columns .column-panel-disabled {
  background-color: #c0c0c047;
  border-radius: 4px;
  cursor: auto;
}
.v-card__text {
width: auto;
}
.wrapper-toggle {
border: 1px solid silver;
border-radius: 4px;
}
.wrapper-toggle .child {
padding: 7.7px;
cursor: pointer;
border-radius: 4px;
}
.wrapper-toggle .child:first-child {
border-top-left-radius: 0;
border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
border-top-right-radius: 0;
border-bottom-right-radius: 0;
margin-left: 1px;
}
::v-deep .v-data-table.product .v-data-table-header {
background-color: #D9D9D9;
}
::v-deep .v-data-table.product {
border: 1px solid silver;
}
::v-deep .v-data-table.product .v-data-table__wrapper::-webkit-scrollbar {
width: 8px;
height: 8px;
}
::v-deep .v-data-table.product .v-data-table__wrapper::-webkit-scrollbar-thumb {
background-color: silver;
}
::v-deep .v-data-table.product .v-data-table__wrapper::-webkit-scrollbar-track {
background-color: #f1f1f1;
}
::v-deep .v-data-table.product > .v-data-table__wrapper > table > thead > tr > th {
font-size: 8.3pt;
border-left: 1px solid silver;
padding: 0 9px;
color: black;
height: 40px !important;
}
::v-deep .v-data-table.product > .v-data-table__wrapper > table > thead > tr > th:first-child {
border-top-right-radius: 4px;
}
::v-deep .v-data-table.product > .v-data-table__wrapper > table > thead > tr > th:last-child {
padding: 0 8px 0 4px;
width: 30px;
border-left: none;
border-top-left-radius: 4px;
}
::v-deep .v-data-table.product > .v-data-table__wrapper > table > tbody {
position: relative;
}
::v-deep .v-data-table.product > .v-data-table__wrapper > table > tbody > tr > td {
border-left: 1px solid silver;
padding-right: 10px;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:first-child {
border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
border-top: 1px solid silver;
background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
background-color: #f6f6f6;
}
::v-deep .v-data-table.product > .v-data-table__wrapper > table > tbody > tr > td:last-child {
width: 0;
border-left: none;
padding: 0 8px 0 3.6pt;
}
.custom-input {
position: relative;
}
</style>
